import { AuthMode } from "@nitro-ape/shared/models/enums/auth-mode";
import Cookies from "js-cookie";
import { isServer } from "@tanstack/react-query";
import {
  ACCESS_TOKEN_COOKIE,
  REFRESH_TOKEN_COOKIE,
} from "@nitro-ape/shared/lib/constants";
import { EnsureFreshTokenFunction } from "./types";
import { getEnv } from "../env/env";

const API_BASE_URL = getEnv.VITE_API_URL || "http://localhost:3005/api/v1";
const AUTH_MODE = (getEnv.VITE_AUTH_MODE || AuthMode.header) as AuthMode;

async function getCookie(name: string): Promise<string | undefined> {
  if (isServer) return undefined;
  return Cookies.get(name);
}

function setCookie(name: string, value: string): void {
  if (!isServer) {
    Cookies.set(name, value);
  }
}

let lastRefresh: Promise<boolean> | null = null;
let lastRefreshTime = 0;
const REFRESH_DEBOUNCE_MS = 5000;

export const ensureFreshToken: EnsureFreshTokenFunction = async () => {
  const now = Date.now();
  if (lastRefresh && now - lastRefreshTime < REFRESH_DEBOUNCE_MS) {
    return lastRefresh;
  }
  lastRefreshTime = now;
  lastRefresh = (async () => {
    if (AUTH_MODE === AuthMode.header) {
      const refreshToken = await getCookie(REFRESH_TOKEN_COOKIE);
      if (!refreshToken) return false;
      try {
        const response = await fetch(`${API_BASE_URL}/auth/refresh`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ refresh_token: refreshToken }),
          cache: "no-store",
        });
        if (!response.ok) return false;
        const data = await response.json();
        setCookie(ACCESS_TOKEN_COOKIE, data.access_token);
        setCookie(REFRESH_TOKEN_COOKIE, data.refresh_token);
        return true;
      } catch {
        return false;
      }
    } else {
      try {
        const response = await fetch(`${API_BASE_URL}/auth/refresh`, {
          method: "POST",
          credentials: "include",
        });
        return response.ok;
      } catch {
        return false;
      }
    }
  })();
  return lastRefresh;
}
